<template>
    <div class="end-screen">
 
       <transition name="fade1">
            <div class="absolute-container" v-if="showCompletedMessage"  v-show="!completeLessonResponse || !animationCompleted">                
               <h1>{{ endOfLessonTitle }}</h1>
                <particles class="particles not-interactive" ref="particles" />
            </div>
        </transition>

        <transition name="fade1" v-if="animationCompleted && isDemo">
            <div class="absolute-container">
                <div class="section-content d-flex justify-content-center align-items-center">
                    <div class="container d-flex justify-content-center">
                        <div class="card card-demo" > 
                            <div class="card-body" v-if="!isViewingSegment"> 

                                <template v-if="!isLoggedIn">
                               <h2 >Create a Free Account</h2>                                   
                                <p>We hope you enjoyed this sample Lesson. To unlock the full capabilities of Emurse, you need to create an account or log in.</p>

                                <div>
                                    <h4>Account Benefits</h4>
                                    <ul>
                                        <li>Personalized review queue that helps you study what you need to review most</li>
                                        <li>Track your progress on a personalized dashboard</li>
                                        <li>Run customizeable drills</li>
                                    </ul>
                                </div>
                                </template>

                                <template v-if="isLoggedIn">
                                    <h2>Demo Complete</h2>
                                    <p>Demo completed.  You may go back to the previous page or return to the dashboard.</p>
                                </template>

                                <div class="demo-continue">
                                    <button class="btn btn-secondary mr-1" @click="back">
                                        <icon :name="'chevron-left'" />
                                     Back</button>
                                    <a class="btn btn-primary" :href="getContinueUrl()" >
                                        <span v-if="!isLoggedIn && lessonController.options?.courseUid=='demo'">Sign Up</span>
                                        <span v-else-if="lessonController.options?.courseUid!='demo'"> 
                                            <span>Enroll for Free</span>
                                        </span>
                                        <span v-else>Dashboard</span>

                                        <icon :name="'chevron-right'" />
                                    </a>

                                </div>
                            </div>
                            <div class="card-body" v-else> 
                            <h2>Preview Complete</h2>
                            <p>You've completed this preview.  You may go back to the previous page, or view the full demo.</p>
                                <button class="btn btn-secondary">Back <icon :name="'back'" /> </button> 
                                <a class="btn btn-primary" :href="`/course/${lessonController.courseUid}/lesson/${lessonController.lessonUid}`">View Full Demo</a>
                            </div> 
                        </div> 
                    </div>

                </div>
            </div>
        </transition>
 
        <transition name="fade1">
            <div class="absolute-container"  v-if="!isDemo && completeLessonResponse && !showUnlocks && animationCompleted" > 
                <section class="section-content">
                   <div class="container">
                       <div class="card">

                        <!-- "quickstudy" | "review" | "wordlist-drill" | "lesson-drill" -->
                        <div class="card-body user-select-none" v-if="lessonController.lessonOptions.mode=='quickstudy' || 
                                                                      lessonController.lessonOptions.mode=='wordlist-drill' || 
                                                                      lessonController.lessonOptions.mode=='lesson-drill' ">
                            <h1>Drill Completed</h1>
                            <h4 v-if="termsScored">{{termsScored}} terms practiced</h4>
                            
                            <a class="btn btn-primary mr-2" v-if="courseUid"
                            @click="shellController.splash('course',true,'Loading Course')"
                            :href="courseHref" ><span>Continue to Course</span>
                                <icon :name="'chevron-right'" /></a>   
                        </div>
 
                        <div class="card-body" v-if="!lessonController.lesson.uid && lessonController.lessonOptions.mode=='review'">
                            <h1>Review Results</h1>
                            <h4 v-if="termsScored">{{termsScored}} terms practiced</h4>

                            <div class="p-2">Good job, you're clearing your queue! You have <span>{{termsInReviewQueue}}</span> items left in your review queue.</div>

                            <a class="btn btn-secondary mr-2"
                            @click="shellController.splash('course',true,'Loading Dashboard')"
                            href="/dashboard"  >Back to Dashboard</a>  
                            <a class="btn btn-secondary mr-2" v-if="courseUid" 
                            @click="shellController.splash('course',true,'Loading Course')"
                            :href="courseHref" >Continue to Course</a>
                            <a v-if="termsInReviewQueue>0" class="btn btn-primary" 
                                @click="shellController.splash('course',true,'Loading Review')"
                                :href="`/course/${lessonController.courseUid}/review`" >Continue Review</a>
                        </div>

                        <div class="card-body" v-if="lessonController.lesson.uid">
                        <h1 >Results</h1>

                        <div class="d-flex flex-wrap justify-content-center" >
                            <div class="p-4">

                                <h4 class="mb-0"><i>this session</i></h4>
                                <div class="d-flex justify-content-center">
                                    <div class="p-2" v-if="newTerms>0 || terms.length>termsScored">
                                        <div>
                                            <strong>Encountered</strong>
                                        </div>
                                        <div class="d-flex  justify-content-center">
                                            <div v-if="newTerms>0"><span class="badge badge-success mr-1"><icon :name="'emurse-new'" />  x {{newTerms}} new </span></div> 
                                            <div v-if="terms.length>termsScored"><span class="badge badge-secondary">{{terms.length}} total </span></div> 
                                        </div>
                                    </div>
                                    <div class="p-2"> 
                                        <div>
                                            <strong>Scored</strong>
                                        </div>
                                        <div><span class="badge badge-secondary"><icon :name="'reps'" />  x {{termsScored}}</span></div> 
                                    </div>
                                    
                                </div>
                            </div>

                            <div v-if="completeLessonResponse.termReport.totalEncountered>=terms.length" class="p-4">
                            <h4 class="mb-0"><i>all time</i></h4>

                            <div class="d-flex justify-content-center">
                                <div class="p-2">
                                    <div>
                                        <strong>Encountered</strong>
                                    </div>
                                    <div class="badge badge-secondary"> {{completeLessonResponse.termReport.totalEncountered}} / {{completeLessonResponse.termReport.retentionGroups?.length  }}</div> 
                                    
                                </div>
                                <div class="p-2"> 
                                    <div>
                                        <strong>Scored</strong>
                                    </div>
                                    <div class="badge badge-secondary">
                                        <span >{{ completeLessonResponse.termReport.totalTermsScored }} / {{ completeLessonResponse.termReport.totalTermsScoredAvailable }} </span>
                                    </div>
                                 </div>
                                
                            </div>
 
                            </div>
 
                        </div>

                        <hr />

                        <div class="d-flex flex-wrap justify-content-center" >
                            <div v-if="moreToDo || allowPractice" class="p-4">

                                <template v-if="moreToDo">
                                    <div>There's more to learn in <strong>{{ lessonController.lesson.title }}</strong></div>
                                    <div><i>Replay this Lesson with new terms and exercises.</i></div>
                                </template>
                                <template v-else> 
                                    <div>Strengthen your understanding?</div>
                                    <div><i>Replay this Lesson with selected terms and exercises.</i></div>
                                </template> 

                                <lesson-item class="icon-only mt-3" :showTitle="false" :urlSuffix="'/practice'" :lesson="lessonController.lesson" :course="course"  >
                                    <template  v-slot:badge-right >
                                        <span class="badge badge-primary badge-round" >     
                                            <span>Go</span>
                                            <icon :name="'chevron-right'" />
                                        </span>
                                    </template>
                                </lesson-item>
                                <div class="d-flex justify-content-center">
                                    <div v-if="scoredToGo>0" class="badge badge-secondary">{{scoredToGo}} terms  remaining</div>
                                    <div v-else-if="encounteredToGo>0" class="badge badge-secondary">{{encounteredToGo}} terms remaining</div>
                                </div>
                                 <!-- <a class="btn badge badge-primary"
                                    @click="shellController.splash('course',true,'Loading Lesson')"
                                    :href="`/course/${lessonController.courseUid}/lesson/${lessonController.lesson.uid}`" >Go</a> -->

                             </div>

                                <div   class="p-4" v-if="completeLessonResponse.nextLesson">
                                <div>Advance to <strong>{{completeLessonResponse.nextLesson.title}}</strong></div>
                                <div><i>start the next lesson</i></div>
                      
                                <lesson-item class="icon-only  mt-3" :showTitle="false" :lesson="completeLessonResponse.nextLesson" :course="course"  >
                                    <template  v-slot:badge-right >
                                        <span class="badge badge-primary badge-round" >     
                                            <span class="go">Go</span>
                                            <icon :name="'chevron-right'" />
                                        </span>
                                    </template>
                                </lesson-item>


                                                                 <!-- <a class="btn badge badge-primary"
                                    @click="shellController.splash('course',true,'Loading Lesson')"
                                    :href="`/course/${lessonController.courseUid}/lesson/${lessonController.lesson.uid}`" >Go</a> -->

                                </div>

                            </div>

                            <div class="d-flex flex-wrap lesson-horizontal pt-4"> 
                            <a v-if="!lessonController.courseUid" class="btn btn-secondary btn-responsive mr-2"
                            @click="shellController.splash('course',true,'Loading Dashboard')"
                            href="/dashboard" > Back to Dashboard</a>
                            <a 
                            @click="shellController.splash('course',true,'Loading Course')"
                                    v-if="lessonController.courseUid" class="btn btn-secondary  btn-responsive mr-2" :href="`/course/${lessonController.courseUid}`" >Back to Course</a>  


                                <a v-if="!completeLessonResponse.nextLesson" class="btn btn-primary  btn-responsive"
                                @click="shellController.splash('course',true,'Loading...')"
                                :href="continueUrl" >Continue</a>
                            </div>
               
                            </div>
                            <!--card body-->
                        </div>
               

 
                   </div>
               </section>  
            </div>
        </transition>
        <transition name="scale">            
            <unclaimed-unlocks v-if="!isDemo && showUnlocks && animationCompleted && completeLessonResponse"  :unlocks="completeLessonResponse.unlocks" @closed="showUnlocks=false" @completed="showUnlocks=false" />
        </transition> 
    </div>
</template>

<script lang="ts">
import { CompleteLessonResponse, Lesson } from '@/data/repository/CourseRepository';
import {Options, Prop,Watch,Inject, Vue } from 'vue-property-decorator';
import UnclaimedUnlocks from '@/components/unlocks/UnclaimedUnlocks.vue';
import Particles from '../core/Particles.vue';
import { LessonController } from '@/controllers/LessonController';
// import { icon } from '../shell/Shell';
import LessonItem from '@/components/course/LessonItem.vue';
import Icon from '@/components/core/Icon.vue';
import { Guid } from '@/EmurseCore';

 import {getCourseUidFromController, getCourseHrefFromController} from './CardViewer';
import { ShellController } from '../shell/Shell'; 

@Options({components:{UnclaimedUnlocks,Particles, LessonItem, Icon}})
export default class LessonEndScreen extends Vue
{  
    public showCompletedMessage = true;
    //VM
    public showUnlocks = false;
    public animationCompleted = false;
    public continueUrl = "/dashboard";
    public moreToDo=false;
    //

    public _endOfLessonTitle = ["Great Progress!", "Nice Work!"].sort( (a,b)=> Math.random()>.5 ? -1 : 1 )

    public get endOfLessonTitle() {
        return this._endOfLessonTitle[0];
    }
    // public icon = icon;
    
    @Prop() public completeLessonResponse?: CompleteLessonResponse;
    @Prop({default: 0}) public termsInReviewQueue!: number;
    @Prop({default: 0}) public termsScored!: number;
    @Prop({default: 0}) public termsRevieiwed!: number;
    @Prop({default: true}) public isLoggedIn!: boolean;

    @Prop({default: 0}) public newTerms!: number;
    @Prop() public terms!: any[];

    @Inject() public lessonController!: LessonController;
    @Inject() public shellController!: ShellController;
    
    @Watch("completeLessonResponse") completeLessonResponseChanged() {
        if (this.completeLessonResponse)
        {
            this.showUnlocks=  this.completeLessonResponse.unlocks && this.completeLessonResponse.unlocks.length>0;
            this.createSummary();
        }

        
    }

    public summaryCreated = false;
    public scoredToGo = 0;
    public encounteredToGo = 0;


    public get allowPractice(): boolean
    {
        return this.lessonController?.lesson?.enablePractice && this.completeLessonResponse?.isReviewable && this.lessonController?.courseUid ? true : false
    } 

    public createSummary()
    {

        if (this.completeLessonResponse?.termReport && !this.summaryCreated)
        { 
            //cards - totalCardsScored / totalCardsScoredAvailable
            //terms - totalTermsScored / totalTermsScoredAvailable

            this.scoredToGo= this.completeLessonResponse.termReport.totalTermsScoredAvailable - this.completeLessonResponse.termReport.totalTermsScored;
            
            this.encounteredToGo = this.completeLessonResponse.termReport.totalEncountered -  this.completeLessonResponse.termReport.retentionGroups?.length;
            this.moreToDo=(this.scoredToGo>0 || this.encounteredToGo>0)
            this.summaryCreated=true;
        }
    }

    public getCourseEnrollmentUrl()
    {
        return  `/course/${this.lessonController.options.courseUid}/enroll`;
    }

    public getContinueUrl()
    {
        if (this.lessonController.options.courseUid=='demo')
        {
            return '/dashboard'
        }
        else if (!this.isLoggedIn)
        {
            const returnUrl=this.getCourseEnrollmentUrl().split('/').join('%2f');
            return '/Identity/Account/Register?returnUrl=' + returnUrl;
        }
        else { 
            return this.getCourseEnrollmentUrl();
 
        }
    }
 
    public getEnrollUrl()
    {
        let url = "/dashboard";
//https://localhost:44334/course/RgTkFdB/lesson/bHcCVfB/enroll
        this.lessonController.options

    }

    public back()
    {
        history.back();
    }

    public get isDemo(): boolean
    {
        return this.lessonController.options.isDemo;
    }
 

    public get course()
    {
        return {uid: this.courseUid};
    }

    public get courseHref()
    {
        return getCourseHrefFromController(this.lessonController);
    }

    public get courseUid()
    {
        return getCourseUidFromController(this.lessonController);
    }

    public hasIcon(lesson: Lesson)
    {
        return lesson && lesson.description && lesson.description.images && lesson.description.images.icon;
    }

    public get isViewingSegment()
    {
        return this.lessonController.options.segmentId && 
        Guid.empty!=this.lessonController.options.segmentId;
    }

    public created()
    {
        if (this.isViewingSegment)
        {
            this.animationCompleted=true;  
            this.showCompletedMessage=false;          
        }
    }

    public mounted()
    {  
        if (!this.isViewingSegment)
        {
            this.generateConfetti();
            this.createSummary();
        }


    }

    protected doThings(e: MouseEvent)
    {
        const particles=(this.$refs.particles as Particles);
        particles.confetti(e.x,e.y,90);
    }

   public generateConfetti(blasts=6,duration=2000)
   { 
      const particles=(this.$refs.particles as Particles);

      if (particles && particles.$el)
      {
        const y=particles.$el.clientHeight/2;
        const boxSize = particles.$el.clientWidth/2;

        let x = boxSize/2; 
        const nextConfetti = boxSize/(blasts-1);
        let blast=0; 

        const interval = duration/blasts;

        const confettiBlaster =  setInterval(()=>{
            particles.confetti(x,y,90);
            x+=nextConfetti;

            if (++blast>=blasts) {
            clearInterval(confettiBlaster); 
            }
        },interval);

        setTimeout(()=>{
           this.animationCompleted=true;
        },duration+250);
      }
      else {
         this.animationCompleted=true;
      }

   }

}
</script>

<style lang="scss" scoped>
@import '@/theme/_helpers.scss';

    .file-upload { display:none;}
    .end-screen {
        width:100vw;
        height:100vh;
        position: relative;

        .demo-continue {
            display: flex;
            justify-content: right;
        }

        .badge-round.go {
            padding-left: .10rem;
        }

        .lesson-horizontal {
            display: flex;
            justify-content: center;
            align-items: center;
            h4 {
                display: inline-block;
                padding:0;
                margin:0;
            }
        }

        .badge .bi {
            width:.65rem;
            height:.65rem;
        }

        .card-demo {
            max-width:30rem;
            text-align: left;
        }

        .lesson-icon {
            background: $primary;
            height:2.5rem;
            width:2.5rem;
        }

        .particles {
            position: absolute;
            top:0px;
            right:0px;
            bottom:0px;
            left:0px; 
            pointer-events: none;
        }

        >.absolute-container {
            position:absolute;
            top:0px;
            right:0px;
            bottom:0px;
            left:0px;
            display: flex;
            align-content: center;
            align-items: center;
            justify-content: center;
            justify-items: center;
            z-index:1
        }
    }

</style> 
 